// Autogenerated file
export const shippingOrderOperationTypesEnum = {
    Loading: "Loading",
    Unloading: "Unloading",
};
export const shippingOrderOperationTypes = [
    { label: "Погрузка", value: "Loading" },
    { label: "Выгрузка", value: "Unloading" },
];
